import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { responseHandler } from "@msuite/ui/utils";
import { type ArticleGroupFormSchema, articleGroupFormSchema } from "@msuite/utils/schemas";
import { FormProvider, useForm } from "react-hook-form";
import { ArticleGroupForm } from "@/forms/article-group-form";
import { client } from "@/hono";

/** Props Interface */
interface AddArticleGroupModalProps extends ModalProps {
	onComplete?: () => Promise<void>;
}

export function AddArticleGroupModal({ onClose, isOpen, onComplete }: AddArticleGroupModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(articleGroupFormSchema),
		defaultValues: {
			number: 0,
			autoGenerateNumber: true,
		},
		reValidateMode: "onSubmit",
	});

	/** Functions */
	async function handleOnSubmit(json: ArticleGroupFormSchema) {
		const response = await client.stock["article-groups"].$post({
			json,
		});
		await responseHandler(response);
		await onComplete?.();
		onClose();
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				title={t("stock.add_article_group")}
				isOpen={isOpen}
				onClose={onClose}
				onSubmit={methods.handleSubmit(handleOnSubmit)}
			>
				<Modal.Body>
					<ArticleGroupForm />
				</Modal.Body>
				<Modal.FooterForm />
			</Modal>
		</FormProvider>
	);
}
